module.exports = __webpack_public_path__ + "static/media/logo.47a92ce1.svg";